import React, { useEffect, useState } from 'react'
import { InputGroup, Input, Box, InputLeftElement } from '@chakra-ui/react'
import { FieldSearchProps } from './interface'
import { Search2Icon } from '@chakra-ui/icons'

const FieldSearch: React.FC<FieldSearchProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  const [localValue, setLocalValue] = useState('')

  const onKeyDown = (e: any) => {
    if (e.code === 'Enter') {
      onChange(e.target.value)
      setLocalValue(e.target.value)
    }
  }

  useEffect(() => {
    setLocalValue(value || '')
  }, [value])

  return (
    <Box flex={1}>
      <InputGroup>
        <Input
          placeholder={placeholder}
          size="sm"
          pl="40px"
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          onKeyDown={onKeyDown}
        />
        <InputLeftElement h="32px">
          <Search2Icon />
        </InputLeftElement>
      </InputGroup>
    </Box>
  )
}

export default FieldSearch
